import React, { Component,Fragment } from 'react';
import PropTypes from 'prop-types';
import WithStyles from '@material-ui/core/styles/withStyles';
import {Link} from 'react-router-dom';
import dayjs from 'dayjs';
import EditDetails from './EditDetails'

//MUI stuff
import Button from '@material-ui/core/Button';
import MuiLink from '@material-ui/core/Link';
import { Paper, Typography} from '@material-ui/core';
import LinearProgress from '@material-ui/core/LinearProgress';

//Icons
import LocationOn from '@material-ui/icons/LocationOn';
import LinkIcon from '@material-ui/icons/Link';
import CalendarToday from '@material-ui/icons/CalendarToday';
import EditIcon from '@material-ui/icons/Edit';
import KeyboardReturn from '@material-ui/icons/KeyboardReturn';

//Redux Stuff
import {connect} from 'react-redux';
import {logoutUser, uploadImage} from '../../redux/actions/userActions';
import MyButton from '../../util/MyButton';




const styles=(theme)=>({
    ...theme.spreadThis,
    paper: {
        padding: 20
      },
      profile: {
        '& .image-wrapper': {
          textAlign: 'center',
          position: 'relative',
          '& button': {
            position: 'absolute',
            top: '80%',
            left: '70%'
          }
        },
        '& .profile-image': {
          width: 200,
          height: 200,
          objectFit: 'cover',
          maxWidth: '100%',
          borderRadius: '50%'
        },
        '& .profile-details': {
          textAlign: 'center',
          '& span, svg': {
            verticalAlign: 'middle'
          },
          '& a': {
            color: theme.palette.primary.main
          }
        },
        '& hr': {
          border: 'none',
          margin: '0 0 10px 0'
        },
        '& svg.button': {
          '&:hover': {
            cursor: 'pointer'
          }
        }
      },
      buttons: {
        textAlign: 'center',
        '& a': {
          margin: '20px 10px'
        }
      }

});
    

class Profile extends Component {
  handleLogout = () =>{
    this.props.logoutUser();
  }  
  
  handleImageChange= (event)=>{
        const image = event.target.files[0];
        const formData = new FormData();
        formData.append('image', image, image.name);
        this.props.uploadImage(formData);

    }
    handleEditPicture = () =>{
        const fileInput = document.getElementById('imageInput');
        fileInput.click ();   
    }
    render() {
        const {
            classes, 
                user:{
                    credentials:{
                        handle, 
                        createdAt, 
                        imageUrl, 
                        bio, 
                        website, 
                        location
                    },
                    loading,
                    authenticated
                }} =this.props
                let profileMarkup = !loading ?(authenticated ? (
                    <Paper className ={classes.paper}>
                        <div className ={classes.profile}>
                            <div className="image-wrapper">
                             <img src={imageUrl} alt="profile" className="profile-image"/>
                             <input
                              type="file"
                              id="imageInput"
                              hidden="hidden"
                              onChange={this.handleImageChange}/>
                             
                             <MyButton tip="Edit Profile picture" onClick={this.handleEditPicture} btnClassName="button">
                               <EditIcon color="primary"></EditIcon>
                             </MyButton>
                             </div>
                             <hr/>
                             <div className="profile-details">
                                <MuiLink component={Link} to={`/users/${handle}`} color="primary" variant="h5">
                                    @{handle}
                                </MuiLink>
                                <hr/>
                                {bio &&<Typography variant="body2">{bio}</Typography>}
                                <hr/>
                                {location && (
                                    <Fragment>
                                    <LocationOn color="primary"/> <span>{location}</span>
                                    <hr/>
                                    </Fragment>
                                )}
                                {website &&(
                                    <Fragment>
                                        <LinkIcon color="primary"/>
                                        <a href={website} target="_blank" rel="noopener noreferrer" >
                                        {' '}{website}
                                        </a>
                                        <hr/>
                                    </Fragment>
                                )}
                                 <CalendarToday color="primary"/>{' '}   
                                 <span>Joined {dayjs(createdAt).format('DD MMM YYYY')}</span>
                             </div>
                             <MyButton tip="Logout" onClick={this.handleLogout}>
                                   <KeyboardReturn color="primary"></KeyboardReturn>
                                 </MyButton>
                                  
                                  <EditDetails/>
                        </div>
                    </Paper>
                ):(
                    <Paper className={classes.paper}>
                        <Typography variant="body2" align="center">
                        You are not logged in, please login or signup
                        </Typography>
                        <div className={classes.buttons}>
                            <Button variant="contained" color="primary" component={Link} to="/login">
                            Login
                            </Button>
                            <Button variant="contained" color="secondary" component={Link} to="/signup">
                            Signup
                            </Button> 
                        </div>
                    </Paper>
                )):<LinearProgress variant="query" />
        return profileMarkup;
    }
}

const mapStateToProps = (state) =>({
    user:state.user
});

const mapActionsToProps={logoutUser, uploadImage}

Profile.propTypes ={
    logoutUser:PropTypes.func.isRequired,
    uploadImage:PropTypes.func.isRequired,
    user:PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired
}

export default connect(mapStateToProps, mapActionsToProps)(WithStyles(styles)(Profile))
